<template>
  <div>
    <el-card v-if="loading">
      <i class="el-icon-loading"></i>
      資料載入中...
    </el-card>
    <el-card body-style="padding: 0" v-else>
      <div slot="header" class="card_header">
        <span>公司-部門別管理</span>
        <el-input class="w-200px" v-model="search" size="mini" placeholder="搜尋"/>
      </div>
      <ezoom-table
          title="公司-部門列表"
          :data="companys"
          :search="search"
          :columns="columns"
      >
        <template slot="buttons">
          <el-button @click.stop="openDialog({},'add')" type="primary"
                     size="small" icon="el-icon-plus">
            新增
          </el-button>
        </template>
        <el-table-column
            fixed="left"
            label="操作"
            width="150">
          <template slot-scope="scope">
            <el-button @click.stop="openDialog(scope.row,'update')" type="warning"
                       size="small" icon="el-icon-edit"/>
            <el-popconfirm title="確定要刪除此員工嗎？"
                           @onConfirm="del(scope.row)"
                           @onCancel="()=>{}"
                           confirmButtonText="確定"
                           cancelButtonText="取消">
              <el-button @click.stop="" slot="reference" type="danger"
                         size="small" icon="el-icon-delete"/>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" sortable label="公司名稱" width="200"/>
        <el-table-column prop="companyId" sortable label="統一編號" width="130"/>
        <el-table-column prop="companyNo" sortable label="公司代碼" width="130"/>
        <el-table-column prop="departmentNo" sortable label="部門代碼"/>
      </ezoom-table>
    </el-card>
    <CrudCompany/>
  </div>
</template>

<script>
import {onMounted} from "@vue/composition-api";
import EzoomTable from "@/components/EzoomTable.vue";
import CrudCompany from "./CrudCompany.vue";
import {setNavTitle} from "@/views/useNavTitle";
import MessageService from "@/components/Message";
import {columns, companys, loading, search, init, del, openDialog} from "./useCompany.js";

export default {
  name: "Employee",
  components: {
    EzoomTable,
    CrudCompany
  },
  setup() {

    onMounted(() => {

      setNavTitle("公司-部門別管理")

      init()
          .then()
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    })

    return {columns, companys, search, loading, del, openDialog}
  }
};
</script>

<style scoped>
</style>
